/** W17 Final GOT Grade → Update (user answer 3, 2026-10-05). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { GotFinalGradeUpdatePage } from "@/features/got/components/final-grade-page";

export const Route = createFileRoute("/_app/quality/got/final-grade/$id")({
  beforeLoad: () => {
    if (!useAuth.getState().can("got.final_grade")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return <GotFinalGradeUpdatePage id={Number(id)} />;
}
